var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0256 3.75206L4.72077 4.72077L3.75206 11.0256L14.8343 22.1078C14.9147 22.1881 15.0236 22.2332 15.1372 22.2332C15.2507 22.2332 15.3597 22.1881 15.44 22.1078L22.1078 15.44C22.1881 15.3597 22.2332 15.2507 22.2332 15.1372C22.2332 15.0236 22.1881 14.9147 22.1078 14.8343L11.0256 3.75206ZM22.7154 16.0469L23.3204 16.6518L16.6518 23.3204L16.6514 23.3208C16.2497 23.722 15.705 23.9475 15.1372 23.9475C14.5693 23.9475 14.0247 23.722 13.6229 23.3208L13.6225 23.3204L2.46785 12.1657C2.31307 12.0154 2.19314 11.8329 2.11658 11.6311C2.03864 11.4256 2.00763 11.2053 2.0258 10.9863C2.02745 10.9664 2.02979 10.9467 2.03281 10.927L3.04042 4.369C3.07587 4.02916 3.22703 3.71135 3.46919 3.46919C3.71135 3.22703 4.02916 3.07587 4.369 3.04042L10.927 2.03281C10.9467 2.02979 10.9664 2.02745 10.9863 2.0258C11.2053 2.00763 11.4256 2.03864 11.6311 2.11658C11.8329 2.19314 12.0154 2.31307 12.1657 2.46785L23.3204 13.6225L23.3208 13.6229C23.722 14.0247 23.9475 14.5693 23.9475 15.1372C23.9475 15.705 23.722 16.2497 23.3208 16.6514L22.7154 16.0469Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.302565 0.302443C0.6373 -0.0322922 1.18001 -0.0322922 1.51475 0.302443L7.51475 6.30244C7.84948 6.63718 7.84948 7.17989 7.51475 7.51463C7.18001 7.84936 6.6373 7.84936 6.30257 7.51463L0.302565 1.51463C-0.0321701 1.17989 -0.0321701 0.637178 0.302565 0.302443Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingTag);
export default __webpack_public_path__ + "static/media/shopping-tag.8f9dac98c764e059b654f0e4f4011351.svg";
export { ForwardRef as ReactComponent };